export enum FaqActionTypes {
    API_RESPONSE_SUCCESS = "@@faq/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@faq/API_RESPONSE_ERROR",
  
    CREATE_FAQ = "@@faq/CREATE_FAQ",
    GET_FAQ = "@@faq/GET_FAQ",
    UPDATE_FAQ = "@@faq/UPDATE_FAQ",
    DELETE_FAQ = "@@faq/DELETE_FAQ",
  }